import { render, staticRenderFns } from "./RsaConfigurazioneSettingLivelliListComponent.vue?vue&type=template&id=459a4871"
import script from "./RsaConfigurazioneSettingLivelliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSettingLivelliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports